<script>
import VueTagsInput from '@johmun/vue-tags-input'
import AddAdmins from '@adminGroups/mixins/add-admins.vue'

export default {
  components: {
    VueTagsInput,
  },
  mixins: [AddAdmins],
  props: {
    itemOpen: { type: Number, required: false, default: 0 },
    companyId: { type: [String, Number], required: false, default: null },
    groupId: { type: [String, Number], required: false, default: null },
    isEditForm: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      groupAccess: this.itemOpen,

      userTag: '',
      userTags: [],
      userDisplayTags: [],
    }
  },
  watch: {
    userTag: 'searchUsers',
  },
  methods: {
    getFormData() {
      return { open: this.groupAccess }
    },
    updateUserTags(newTags) {
      this.userDisplayTags = []
      this.userTags = newTags
    },
  },
}
</script>

<template>
  <div>
    <div class="mb-12">
      <h3 class="text-2xl text-blue-darker mb-5">Group Access</h3>
      <div class="flex items-center mb-2">
        <span :class="$style.radioBox">
          <input
            id="openHub"
            v-model="groupAccess"
            type="radio"
            name="groupAccess"
            :value="1"
            :class="$style.radio"
          />
        </span>
        <label for="openHub" class="ml-2">
          <span class="mr-2">
            Open Group:
          </span>
          <span class="text-gray-light">
            anyone can join this group
          </span>
        </label>
      </div>
      <div class="flex items-center mb-2">
        <span :class="$style.radioBox">
          <input
            id="closedHub"
            v-model="groupAccess"
            type="radio"
            name="groupAccess"
            :value="0"
            :class="$style.radio"
          />
        </span>
        <label for="closedHub" class="ml-2">
          <span class="mr-2">
            Closed Group:
          </span>
          <span class="text-gray-light">
            users must be added or invited by admin
          </span>
        </label>
      </div>
    </div>

    <div v-if="isEditForm">
      <h3 class="text-2xl text-blue-darker mb-5">Group Admins</h3>
      <div class="w-full mb-4">
        <label for="searchStr" class="block mb-3">Add Admins:</label>
        <VueTagsInput
          v-model="userTag"
          :tags="userTags"
          :autocomplete-items="userDisplayTags"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          placeholder="Search for individual users"
          @tags-changed="updateUserTags"
        />
      </div>
      <button
        class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
        @click="addSearchAdmins"
      >
        Add selected users as admins to Group
      </button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.radioBox {
  @apply flex border border-gray rounded-full h-4 w-4 mr-1;
}
.radio {
  @apply appearance-none cursor-pointer inline-block select-none bg-white outline-none rounded-full align-middle;

  width: 14px;
  height: 14px;
}
.radio:checked {
  @apply bg-blue border-2 border-solid border-white;
}
</style>
